// extracted by mini-css-extract-plugin
module.exports = {"spinner":"PendingSpinner_spinner___My6u","inverse":"PendingSpinner_inverse__IZtP_"};